import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">What We Restore</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">
              Four disasters.<br /><span className="text-gradient-gold">One response team.</span>
            </h2>
          </div>
          <p className="max-w-sm text-[#A3A3A3] leading-relaxed">
            From the first call to the final rebuild, we handle every phase of restoration in-house, so you deal with one trusted crew, not five.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              className="group relative border border-white/10 bg-[#0d0d0d] overflow-hidden hover:border-gold/50 transition-colors duration-500"
              data-testid={`service-card-${s.id}`}
            >
              <div className="relative h-60 overflow-hidden">
                <img src={s.image} alt={s.title} className="h-full w-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-[#0d0d0d]/30 to-transparent" />
                <span className="absolute top-5 left-5 font-mono text-xs tracking-widest text-gold">{s.num}</span>
                <span className="absolute top-5 right-5 font-mono text-[10px] tracking-widest uppercase text-[#A3A3A3] border border-white/15 px-3 py-1 bg-black/40 backdrop-blur">{s.tag}</span>
              </div>

              <div className="p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display text-3xl">{s.title}</h3>
                  <ArrowUpRight className="h-6 w-6 text-gold shrink-0 group-hover:rotate-45 transition-transform duration-500" />
                </div>
                <p className="mt-4 text-[#A3A3A3] leading-relaxed">{s.desc}</p>
                <ul className="mt-6 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-sm text-[#F5F5F0]/80">
                      <span className="h-1.5 w-1.5 bg-gold rounded-full" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
